import { LocalKey } from 'src/types/localStorage.types';
import { make } from 'src/utils/reactives.util';

export enum Content {
  Comments = 'Comments',
  Activity = 'Activity',
  Insights = 'Insights',
}

interface DocPanelState {
  content: Content;
  isExpanded: boolean;
  autoFocus: boolean;
  isHovered: boolean;
}

export const {
  hookState: useDocPanel,
  hookValue: useGetDocPanel,
  getValue: getDocPanel,
  setValue: setDocPanel,
} = make<DocPanelState>({
  defaultState: {
    content: Content.Comments,
    isExpanded: false,
    autoFocus: true,
    isHovered: false,
  },
});

export const closePanel = () => setDocPanel({ isExpanded: false });

export const openCommentsPanel = () => setDocPanel({
  isExpanded: true,
  content: Content.Comments,
});

export const {
  hookValue: useGetInsightSuggestions,
  getValue: getInsightSuggestions,
  setValue: setInsightSuggestions,
} = make<{
  isCollapsed: boolean;
}>({
  localKey: LocalKey.InsightSuggestions,
  crossTabSync: true,
  defaultState: {
    isCollapsed: false,
  },
});

export const toggleInsightSuggestions = () => setInsightSuggestions({ isCollapsed: !getInsightSuggestions().isCollapsed });

export const {
  hookValue: useGetAiGeneratedInsights,
  getValue: getAiGeneratedInsights,
  setValue: setAiGeneratedInsights,
} = make<{
  isCollapsed: boolean;
}>({
  localKey: LocalKey.AiGeneratedInsights,
  crossTabSync: true,
  defaultState: {
    isCollapsed: false,
  },
});

export const toggleAiGeneratedInsights = () => setAiGeneratedInsights({ isCollapsed: !getAiGeneratedInsights().isCollapsed });
